var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlDistStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1242_3538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1242_3538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.51988H9.15186V4.64316H6.1996V4.91185C6.1996 9.81103 6.19848 14.7102 6.19624 19.6094C6.19624 19.8123 6.23353 19.8844 6.45728 19.884C10.1646 19.8761 13.872 19.8761 17.5796 19.884C17.7858 19.884 17.831 19.8228 17.831 19.6237C17.8257 14.7178 17.8243 9.81159 17.8268 4.9051V4.65202H14.8699V3.52578H19.0231V21.0001H5V3.51988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1809 2.67996C11.0745 2.19698 11.232 2.00127 11.6942 2C11.9242 2 12.1551 2 12.3842 2C12.7777 2.00337 12.9377 2.205 12.8581 2.59433C12.8561 2.62157 12.8561 2.64892 12.8581 2.67616C12.9939 2.67616 13.125 2.6732 13.2562 2.67616C13.6626 2.68712 13.9773 2.98324 13.9915 3.38944C14.0041 3.73996 14.0028 4.09175 13.9886 4.44396C13.9723 4.83582 13.6827 5.13868 13.2897 5.14501C12.4324 5.15851 11.5747 5.15851 10.7166 5.14501C10.5397 5.14049 10.3711 5.06813 10.2453 4.9427C10.1195 4.81727 10.0461 4.64823 10.0399 4.47011C10.0219 4.10609 10.0228 3.73996 10.037 3.37341C10.0517 2.99378 10.3483 2.70695 10.7254 2.68206C10.8696 2.67194 11.0154 2.67996 11.1809 2.67996ZM12.0118 3.32532H11.5928C10.9148 3.32532 10.87 3.37003 10.8805 4.0521C10.8846 4.3731 11.0062 4.4988 11.3229 4.50175C11.734 4.50512 12.1446 4.50175 12.5552 4.50175C13.0613 4.50175 13.1418 4.42329 13.1418 3.92261C13.1418 3.85933 13.1418 3.79606 13.1418 3.73321C13.1347 3.47211 13.0006 3.33165 12.7421 3.32574C12.4995 3.32068 12.2556 3.32617 12.0118 3.32617V3.32532Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.54 16.8515H9.87844V9.70814H9.23779C9.56755 9.13195 9.87551 8.59414 10.2015 8.0209L11.1618 9.6938H10.5388L10.54 16.8515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61785 8.02795H8.2828V15.1709H8.92512L7.96143 16.8543C7.63963 16.2933 7.33293 15.7576 7.00317 15.1861H7.61952L7.61785 8.02795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4205 7.89616C15.02 7.89616 15.6192 7.89616 16.2188 7.89616C16.4702 7.89616 16.6164 8.02271 16.6135 8.22644C16.6106 8.43018 16.4631 8.55925 16.2146 8.55967C15.0302 8.56192 13.8454 8.56192 12.6602 8.55967C12.3996 8.55967 12.2496 8.42553 12.2563 8.21294C12.263 8.00836 12.4046 7.89616 12.6644 7.89532C13.2499 7.89476 13.8352 7.89504 14.4205 7.89616Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4221 12.5904C13.8355 12.5904 13.2489 12.5904 12.6623 12.5904C12.3996 12.5904 12.2621 12.4786 12.2563 12.2703C12.2504 12.0619 12.4004 11.9273 12.6661 11.9269C13.8529 11.9244 15.0401 11.9244 16.2275 11.9269C16.4639 11.9269 16.6097 12.0573 16.6139 12.2517C16.6185 12.4563 16.471 12.5892 16.2238 12.5892C15.6229 12.5921 15.0225 12.5904 14.4221 12.5904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4453 15.9606C15.0319 15.9606 15.6174 15.9606 16.2017 15.9606C16.4615 15.9606 16.6174 16.0922 16.614 16.3006C16.6107 16.5018 16.4598 16.6254 16.2097 16.6254C15.0247 16.6254 13.84 16.6254 12.6553 16.6254C12.3771 16.6254 12.2225 16.4676 12.2606 16.2343C12.2899 16.0559 12.4182 15.9614 12.6473 15.9606C13.2465 15.9589 13.8461 15.9606 14.4453 15.9606Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlDistStatement);
export default __webpack_public_path__ + "static/media/bl_dist_statement.9b0ad7dd4bcac0b72e75df15e6905c1f.svg";
export { ForwardRef as ReactComponent };